import React, { useState } from 'react';
import { isNil } from 'lodash';
import { Chip } from '@metarouter-private/mr-mui';

import { useUserContext } from '@ion/user';
import OrgSwitcher from 'app/components/org-switcher';

export default function OrgSwitcherPill() {
  const { currentOrg } = useUserContext();
  const [switcherOpen, setSwitcherOpen] = useState(false);

  if (isNil(currentOrg)) {
    return null;
  }

  return (
    <>
      <Chip
        component="button"
        id="org-switcher-link"
        data-test-id="OrgSwitcherPill"
        variant="outlined"
        color="default"
        label={currentOrg.display_name ?? currentOrg.name}
        onClick={() => setSwitcherOpen(true)}
      />
      {switcherOpen && <OrgSwitcher orgId={currentOrg.id} closeModal={() => setSwitcherOpen(false)} />}
    </>
  );
}
